/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolDirectionsBoatIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-directions-boat"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 22.85Q12 22.85 11.49 22.85Q10.97 22.85 10 22.63Q9.03 22.4 8.15 21.95Q6.85 22.6 5.79 22.73Q4.72 22.85 3.45 22.85Q2.9 22.85 2.52 22.46Q2.15 22.07 2.15 21.52Q2.15 20.98 2.52 20.59Q2.9 20.2 3.45 20.2Q4.05 20.2 4.6 20.18Q5.15 20.15 5.69 20.06Q6.22 19.98 6.76 19.77Q7.3 19.57 7.83 19.23Q7.97 19.13 8.14 19.11Q8.3 19.1 8.45 19.2Q9.2 19.68 10.09 19.91Q10.97 20.15 12 20.15Q13.03 20.15 13.93 19.91Q14.82 19.68 15.55 19.2Q15.7 19.1 15.86 19.1Q16.02 19.1 16.15 19.2Q16.7 19.55 17.23 19.75Q17.75 19.95 18.29 20.05Q18.82 20.15 19.38 20.18Q19.93 20.2 20.52 20.2Q21.07 20.2 21.46 20.59Q21.85 20.98 21.85 21.52Q21.85 22.07 21.46 22.46Q21.07 22.85 20.52 22.85Q19.27 22.85 18.2 22.73Q17.13 22.6 15.85 21.95Q14.97 22.4 14 22.63Q13.03 22.85 12 22.85ZM6.53 5.85L6.53 9.43L11.25 8.05Q11.6 7.92 12 7.91Q12.4 7.9 12.75 8.03L17.48 9.4L17.48 5.85Q17.48 5.85 17.48 5.85Q17.48 5.85 17.48 5.85L6.53 5.85Q6.53 5.85 6.53 5.85Q6.53 5.85 6.53 5.85ZM12 18.65Q10.9 18.65 9.86 18.27Q8.82 17.9 8.18 17.25L8.18 17.25L8.18 17.25Q7.5 17.85 6.61 18.2Q5.72 18.55 4.63 18.68Q4 18.73 3.52 18.34Q3.05 17.95 2.9 17.32L1.8 12.55Q1.68 12.1 1.88 11.69Q2.08 11.28 2.5 11.07L3.88 10.38L3.88 5.85Q3.88 4.72 4.64 3.96Q5.4 3.2 6.53 3.2L8.43 3.2L8.43 2.52Q8.43 1.98 8.81 1.59Q9.2 1.2 9.75 1.2L14.25 1.2Q14.8 1.2 15.19 1.59Q15.57 1.98 15.57 2.52L15.57 3.2L17.48 3.2Q18.6 3.2 19.36 3.96Q20.13 4.72 20.13 5.85L20.13 10.38L21.5 11.07Q21.93 11.28 22.13 11.69Q22.32 12.1 22.2 12.55L21.1 17.32Q20.98 17.93 20.49 18.32Q20 18.73 19.38 18.68Q18.27 18.55 17.39 18.2Q16.5 17.85 15.82 17.25L15.82 17.25L15.82 17.25Q15.18 17.9 14.14 18.27Q13.1 18.65 12 18.65Z" fill={color} />
    </svg>
  );
}
